import axios from "./axios"; // 导入封装的 axios 实例
import {
  API_URLS
} from "./apiUrls"; // 导入接口 URL 集合

// 获取数据
export const getExampleData = (data) => {
  return axios.post(API_URLS.getData, data);
};
// 返回按钮点击
export const deleteOrganizationCode = (organizationCode) => {
  return axios.get(API_URLS.deleteOrganizationCode + organizationCode,);
};
// 提交数据
export const selectCode = (organizeCode) => {
  return axios.get(API_URLS.selectCode + organizeCode,);
};